import { MutationType } from '@tencent/slide-sdk-pb-model';

export const enum MutationSource {
    /**
     * 仅在本地应用 Mutations，不产生其他副作用。
     * 既不进入 Undo/Redo 栈，也不参与协同编辑。
     */
    None = 'none',
    /**
     * 来自首帧数据加载场景的 Mutations。
     * 既不进入 Undo/Redo 栈，也不参与协同编辑。
     */
    Keyframe = 'keyframe',
    /**
     * 上层编辑器通过 MutationAPI 触发的本地编辑操作产生的 Mutations。
     * 应用后进入 Undo/Redo 栈，参与协同编辑。
     */
    Editor = 'editor',
    /**
     * Undo/Redo 操作产生的 Mutations。
     * 不会重复进入 Undo/Redo 栈，参与协同编辑。
     */
    UndoRedo = 'undo-redo',
    /**
     * 协同编辑场景，接收到其他协同者产生的 Mutations。
     * 需要经过转换后，应用到本地快照。协同者产生的 Mutations 不进入 Undo/Redo 栈
     */
    Collaborator = 'collaborator',
    /**
     * 协同编辑场景，接收到其他协同者产生的 Mutations，但经过了冲突处理
     * 需要经过转换后，应用到本地快照。协同者产生的 Mutations 不进入 Undo/Redo 栈
     */
    CollaboratorConflict = 'collaborator',
    /**
     * 离线编辑缓存的 Mutations，
     * 需要经过转换后，应用到本地快照，不进入 Undo/Redo 栈，在线时，会提交到服务端。
     */
    Offline = 'offline',
}

export const MutationTypeKeyMap = {
    [MutationType.Empty]: 'empty',
    [MutationType.SetPresentationProperties]: 'setPresentationProperties',
    [MutationType.SetSlideSize]: 'setSlideSize',
    [MutationType.SetNotesSize]: 'setNotesSize',
    [MutationType.AddPage]: 'addPage',
    [MutationType.RemovePage]: 'removePage',
    [MutationType.MovePage]: 'movePage',
    [MutationType.SetPageProperties]: 'setPageProperties',
    [MutationType.AddShape]: 'addShape',
    [MutationType.RemoveShape]: 'removeShape',
    [MutationType.TransformShape]: 'transformShape',
    [MutationType.MoveShape]: 'moveShape',
    [MutationType.Group]: 'group',
    [MutationType.Ungroup]: 'ungroup',
    [MutationType.SetShapeProperties]: 'setShapeProperties',
    [MutationType.AddSection]: 'addSection',
    [MutationType.RemoveSection]: 'removeSection',
    [MutationType.SetSectionProperties]: 'setSectionProperties',
    [MutationType.BindSectionToSlide]: 'bindSectionToSlide',
    [MutationType.InsertTableRow]: 'insertTableRow',
    [MutationType.InsertTableCol]: 'insertTableCol',
    [MutationType.DeleteTableRow]: 'deleteTableRow',
    [MutationType.DeleteTableCol]: 'deleteTableCol',
    [MutationType.MergeTableCells]: 'mergeTableCells',
    [MutationType.UnmergeTableCells]: 'unmergeTableCells',
    [MutationType.SetTableColWidths]: 'setTableColWidths',
    [MutationType.SetTableRowHeights]: 'setTableRowHeights',
    [MutationType.SetTableCellProperties]: 'setTableCellProperties',
    [MutationType.AddAnimation]: 'addAnimation',
    [MutationType.RemoveAnimation]: 'removeAnimation',
    [MutationType.SetAnimationProperties]: 'setAnimationProperties',
    [MutationType.MoveAnimation]: 'moveAnimation',
    [MutationType.AddTheme]: 'addTheme',
    [MutationType.RemoveTheme]: 'removeTheme',
    [MutationType.SetTheme]: 'setTheme',
    [MutationType.InsertText]: 'insertText',
    [MutationType.DeleteText]: 'deleteText',
    [MutationType.SetTextProperties]: 'setTextProperties',
    [MutationType.SetChartSpaceProperties]: 'setChartSpaceProperties',
    [MutationType.AddSubChart]: 'addSubChart',
    [MutationType.RemoveSubChart]: 'removeSubChart',
    [MutationType.MoveSubChart]: 'moveSubChart',
    [MutationType.SetSubChartProperties]: 'setSubChartProperties',
    [MutationType.SetTextData]: 'setTextData',
    [MutationType.GroupAsSmartArt]: 'group',
    [MutationType.SetTextBodyProperties]: 'setTextBodyProperties',
    [MutationType.UpdateResourceMap]: 'updateResourceMap',
    [MutationType.ComputeGroupTransform]: 'computeGroupTransform',
    [MutationType.SetDiagramData]: 'setDiagramData',
    [MutationType.SetDiagramDrawing]: 'setDiagramDrawing',
    [MutationType.SetDiagrams]: 'setDiagrams',
    [MutationType.AddComment]: 'addComment',
    [MutationType.SetCommentProperties]: 'setCommentProperties',
    [MutationType.RemoveComment]: 'removeComment',
    [MutationType.SetDataExtension]: 'setDataExtension',
    [MutationType.RemoveDataExtension]: 'removeDataExtension',
} as const;
